module.exports = __webpack_public_path__ + "img/announcement-valu.9c3c27db.svg";